module.exports = __webpack_public_path__ + "static/media/ashwin_girish.29ec7dd2.jpeg";